import React, { useState, useEffect } from 'react';
import { Col, Row, Container } from "react-bootstrap";
import PropTypes from 'prop-types';
import { SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_ESIGN_AUTH_KEY, getSessionStorageItem } from '../../../../sessionStorage';
import ApplicationSummary from '../../Common/Status/ApplicationSummary';
import StatusStepCard from '../../Common/Status/StatusStepCard';
import SendStatusEmailButton from '../../Common/Status/SendStatusEmailButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import { format } from 'date-fns';
import './Status.scss';

export default function Status(props) {

  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;

  const esignAuthJSON = getSessionStorageItem(SESSION_STORAGE_ESIGN_AUTH_KEY);

  const MAX_ATTEMPTS = 30;
  const WAIT_SECONDS = 10;

  const passcode = (esignAuthJSON && esignAuthJSON.passcode) || (props.formState.steps.identityVerification.socialSecurityNumber && props.formState.steps.identityVerification.socialSecurityNumber.replace(/-/g, '').substring(5));
  const birthdate = (esignAuthJSON && esignAuthJSON.birthdate) || props.formState.steps.basicInfo.birthdate;
  const applicationID = (esignAuthJSON && esignAuthJSON.applicationID) || props.formState.appIdentifier;

  const [approved, setApproved] = useState(false);
  const [attempts, setAttempts] = useState(1);
  const [loading, setLoading] = useState(true);
  const [statusResponse, setStatusResponse] = useState(null);

  useEffect(() => {
    fetch(`${covrServicesUrl}/api/AppStatus/GetAppStatus?passcode=${passcode}&birthdate=${birthdate}&applicationID=${applicationID}`,
      {
        method: 'GET',
        headers: {
          'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
        }
      })
      .then(res => res.json())
      .then(json => {
        setStatusResponse(json)
        setLoading(false)
      });
  }, [])

  const waiting = () => {
    if (attempts <= MAX_ATTEMPTS) {
      setTimeout(() => setAttempts(attempts + 1), 1000 * WAIT_SECONDS);
    }
  }

  const checkFinalSubmissionStatus = () => {
    fetch(`api/Americo/FinalSubmissionStatus?PolicyNumber=${(statusResponse && statusResponse.PolicyNumber) || props.formState.policyNumber}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
      },
    })
      .then(x => x.json())
      .then(json => {
        if (json.hasSubmitted) {
          setApproved(true);
        }
        else {
          waiting();
        }
      });
  }

  useEffect(() => {
    if (!approved) {
      checkFinalSubmissionStatus();
    }
  }, [attempts])

  if (loading) {
    return <Row className="justify-content-center"><CircularProgress /></Row>;
  }

  return (
    <Container className="status loan-protector">
      <Row>
        <Col lg={8}>
          <p className="statusTitle">Nice job - now it's our turn</p>

          <p className="statusSubTitle">You've completed your application. <br />There's just two more steps on our end.</p>

          <p className="statusNext">Next Steps</p>

          <StatusStepCard active={!approved} stepNumber={1} stepTitle={'Automated Review'} stepStatusLabel={'5 mins'}>
            <AutomatedReview birthdate={birthdate} applicationID={applicationID} passcode={passcode} clientUserID={statusResponse.ClientUserID} />
          </StatusStepCard>

          <StatusStepCard active={approved} stepNumber={2} stepTitle={'Application Decision'} stepStatusLabel={approved ? 'Approved' : 'Approved/Declined'} showTimeIcon={false}>
            <Approved policyNumber={statusResponse.PolicyNumber || props.formState.policyNumber} policyEffectiveDate={statusResponse.PolicyDate ? format(new Date(statusResponse.PolicyDate), 'MM/dd/yyyy') : props.formState.policyEffectiveDate} />
          </StatusStepCard>

          <img src={process.env.PUBLIC_URL + '/americo/americo-status-image.png'} alt={'Americo Logo'} />
        </Col>
        <Col lg={4}>
          <ApplicationSummary firstName={statusResponse.InsuredName}
            lastName=""
            coverageAmount={statusResponse.Coverage}
            premium={statusResponse.Premium}
            term={statusResponse.Term}
            emailAddress={statusResponse.EmailAddress}
            passcode={passcode}
            birthdate={birthdate}
            applicationID={applicationID}
          />
        </Col>
      </Row>
    </Container>
  )
}

function Approved(props) {
  return (
    <React.Fragment>
      <span className='stepTextHeader'>Congratulations your application has been approved!</span><br /><br />

      Policy Number: {props.policyNumber}<br /><br />
      Policy Effective Date: {props.policyEffectiveDate}<br /><br />

      Your policy will be delivered soon, but don't worry - your coverage is in effect now.
      Purchasing life insurance is an important step toward protecting your family's future and securing peace of mind. If you have any questions, don't hesitate
      to reach out to our team using the form to the right.<br /><br />

      <span className='stepTextHeader'>What's next</span><br /><br />

      Now that your application has been approved and accepted, look for an email from Covr containing important information about your policy. Your new policy will be mailed to you
      directly from Americo, with self-addressed stamped envelopes included for any items that need to be returned to Americo. Be watching your email for your certificate of insurance.
    </React.Fragment>
  )
}

Approved.propTypes = {
  policyNumber: PropTypes.string.isRequired,
}

function AutomatedReview(props) {
  return (
    <React.Fragment>
      Your policy application is being reviewed and a decision will be returned shortly. You will receive an email when a decision is returned - usually within 5 minutes.<br /><br />

      <SendStatusEmailButton passcode={props.passcode} birthdate={props.birthdate} applicationID={props.applicationID} clientUserID={props.clientUserID} />
    </React.Fragment>
  )
}

AutomatedReview.propTypes = {
  passcode: PropTypes.string.isRequired,
  birthdate: PropTypes.string.isRequired,
  applicationID: PropTypes.string.isRequired,
  clientUserID: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Americo/steps/Status.js